var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveQuantity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_182",
    "data-name": "Group 182",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_9",
    d: "M0 0H18V18H0z",
    "data-name": "Rectangle 9",
    transform: "translate(2)",
    style: {
      fill: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_8",
    "data-name": "Group 8",
    transform: "translate(8.065 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M699 883h5.87",
    "data-name": "Path 8",
    transform: "translate(-699 -883)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveQuantity);
export default __webpack_public_path__ + "static/media/remove-quantity.de65710ce0ba874cd7d10ce829bba309.svg";
export { ForwardRef as ReactComponent };